import PatchController from '../PatchController';

export default class ProgramFeedController extends PatchController {
	public handle() {
		this.redirect(this.routes.today.indexRoute.href);
	}
}
